import { render, staticRenderFns } from "./HomeTopItem.vue?vue&type=template&id=489cf386&scoped=true&"
import script from "./HomeTopItem.vue?vue&type=script&lang=js&"
export * from "./HomeTopItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeTopItem.vue?vue&type=style&index=0&id=489cf386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cf386",
  null
  
)

export default component.exports